import React from "react"

import LargeNumbers from "@knowit-alma/common/src/components/atoms/LargeNumbers/LargeNumbers"
import RowList from "@knowit-alma/common/src/components/molecules/RowList/RowList"

import styles from "./LargeNumbersList.module.scss"

const LargeNumbersList = ({ list, variant = "primary" }) => {
  const listFormatted = Array.isArray(list)
    ? list.map((item, index) => {
        const url = item.link ? item.link.url : item.url
        const external = item.link ? item.link.target === "_blank" : false
        return (
          <LargeNumbers
            key={index}
            number={item.number}
            text={item.text}
            url={url}
            external={external}
          />
        )
      })
    : []

  return (
    <section
      className={`${styles.element} ${styles[variant]} ${
        list?.length === 1 ? styles.single : ""
      } make-full-width-on-mobile`}
    >
      {listFormatted.length === 1 && <>{listFormatted}</>}
      {listFormatted.length > 1 && (
        <RowList
          columns={3}
          specialClass={`mobile-bottom-margins justify-content-center base-margin-bottom-small`}
        >
          {listFormatted}
        </RowList>
      )}
    </section>
  )
}

export default LargeNumbersList
